import {GruppeInvitasjonTilGodkjenningModell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {Temporal} from "temporal-polyfill";
import {blankMedlemsRolleModell} from "felles-ng2/modell/tommeModeller";

export function blankGruppeInvitasjonTilGodkjenningModell(): GruppeInvitasjonTilGodkjenningModell {
    return {
        id: '',
        gruppeId: '',
        token: null,
        epost: '...',
        navnEllerEpost: '...',
        rolle: blankMedlemsRolleModell(),
        opprettetDato: Temporal.Now.zonedDateTimeISO().toString(),
        gruppeTittel: '...',
        gruppeOrganisasjonsnavn: '...',
        kreverOtpGodkjenning: true,
        kreverEid: false,
        otpValidert: false
    }
}
